import { union } from "../../../types/_types";

import priceTypes from "../../prices/constants/priceTypes";

import { CloudRevenueMeta } from "./CloudRevenueMeta";
import { CloudStartFeeMeta } from "./CloudStartFeeMeta";

// The shape follows from the cost's price type. Add new shapes to both below.
export const CostMeta = union([CloudStartFeeMeta, CloudRevenueMeta]);

export const costMetaByPriceType = {
	[priceTypes.CLOUD_START_FEE_AUDIO]: CloudStartFeeMeta,
	[priceTypes.CLOUD_START_FEE_EBOOK]: CloudStartFeeMeta,
	[priceTypes.CLOUD_REVENUE_LIVE]: CloudRevenueMeta,
	[priceTypes.CLOUD_REVENUE_INACTIVE]: CloudRevenueMeta,
};
